import { useNavigate } from "react-router-dom";
import { useState, useEffect, useMemo } from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import "./DockingMate.css";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import HeroBackground from "../../../assets/hero-background.webp";
import DockingmateAbout from "../../../assets/dockingmate-easy-rent-swap.jpg";
import SwappingYourBerth from "../../../assets/Swapping-your-berth.jpeg";
import HowitWorks from "../../../assets/dockingmate-how-it-works.webp";
import GreenmateAbout from "../../../assets/greenmate-about.webp";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import PublicIcon from "@mui/icons-material/Public";
import HandshakeIcon from "@mui/icons-material/Handshake";
import CheckIcon from "@mui/icons-material/Check";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { MooringMateHomeHeader } from "../../../components/HomeHeader/MooringMateHomeHeader";
import { GeneralFooter, MooringmateFAQ, LanguageDropdown, BerthMap } from "../../../components";
// import { LanguageDropdown } from "../../../components/Dropdown/LanguageDropdown";

export const DockingMate = (props) => {
  const navigate = useNavigate();
  const [selectedLang, setSelectedLang] = useState("en");

  const scrollToBerths = () => {
    const berthsSection = document.getElementById("available-berths");
    if (berthsSection) {
      berthsSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleListBerth = () => {
    navigate("/login", { state: { redirectTo: "/home/create-berth" } });
  };

  const languages = useMemo(() => ([
    {
      code: "en",
      label: "English",
      flag: "https://flagcdn.com/w40/us.png",
    },
    {
      code: "es",
      label: "Spanish",
      flag: "https://flagcdn.com/w40/es.png",
    },
    {
      code: "fr",
      label: "French",
      flag: "https://flagcdn.com/w40/fr.png",
    },
    {
      code: "nl",
      label: "Dutch",
      flag: "https://flagcdn.com/w40/nl.png",
    },
  ]), []);

  useEffect(() => {
    // Handle navigation to faq from any page
    if (document.location.hash === "#faq") {
      const faqSection = document.getElementById("faq");
      if (faqSection) {
        if (faqSection.classList.contains("hideFaq")) {
          faqSection.classList.remove("hideFaq");
        }

        faqSection.classList.add("showFaq");
        faqSection.scrollIntoView({ behavior: "smooth" });
      }
    }

    // Clean up function
    return () => {
      const faqSection = document.getElementById("faq");
      if (faqSection) {
        if (faqSection.classList.contains("showFaq"))
          faqSection.classList.remove("showFaq");
        
        faqSection.classList.add("hideFaq");
      }
    }
  }, [])

  useEffect(() => {
    // Hide all language contents first
    languages.forEach((lang) => {
      const elements = document.querySelectorAll(`[data-lang="${lang.code}"]`);
      elements.forEach((el) => {
        el.style.display = lang.code === selectedLang ? "block" : "none";
      });
    });
  }, [selectedLang, languages]);

  return (
    <Box>
      {/* <CssBaseline /> */}
      <MooringMateHomeHeader />

      {/* New Hero Section */}
      <Box
        component="main"
        className="new-hero-section"
        style={{ backgroundImage: `url(${HeroBackground})` }}
      >
        <Box className="new-hero-overlay">
          <Container maxWidth="lg">
            <Grid container spacing={2}>
              <Grid item xs={12} md={8} lg={7}>
                <div className="new-hero-content">
                  {/* Green Badge */}
                  <div className="hero-badge">
                    <CheckIcon className="badge-icon" />
                    <span>THE MARKETPLACE FOR MARINA BERTHS</span>
                  </div>

                  {/* Main Headline */}
                  <h1 className="hero-headline">
                    Find<span className="dot"></span> Rent<span className="dot"></span> Swap<span className="dot"></span> Sell<span className="dot"></span>
                  </h1>
                  <h2 className="hero-subheadline">
                    Berths, made easy<span className="dot"></span>
                  </h2>

                  {/* Description */}
                  <p className="hero-description">
                    Connecting people looking for a marina berth with those who have one available to rent, swap or sell.
                  </p>

                  {/* CTA Buttons */}
                  <div className="hero-buttons">
                    <Button
                      onClick={scrollToBerths}
                      className="btn-find-berth"
                      startIcon={<SearchIcon />}
                    >
                      FIND A BERTH
                    </Button>
                    <Button
                      onClick={handleListBerth}
                      className="btn-list-berth"
                    >
                      <span className="circled-icon"><AddIcon /></span>
                      LIST YOUR BERTH
                    </Button>
                  </div>
                </div>
              </Grid>
            </Grid>

            {/* Feature Icons */}
            <div className="hero-features">
              <div className="hero-feature">
                <VerifiedUserIcon className="feature-icon" />
                <div className="feature-text">
                  <span className="feature-title">Verified listings</span>
                  <span className="feature-subtitle">Safe & trusted</span>
                </div>
              </div>
              <div className="hero-feature">
                <PublicIcon className="feature-icon" />
                <div className="feature-text">
                  <span className="feature-title">Worldwide coverage</span>
                  <span className="feature-subtitle">Growing marina network</span>
                </div>
              </div>
              <div className="hero-feature">
                <HandshakeIcon className="feature-icon" />
                <div className="feature-text">
                  <span className="feature-title">Direct connections</span>
                  <span className="feature-subtitle">No middlemen</span>
                </div>
              </div>
            </div>
          </Container>
        </Box>
      </Box>

      {/* For Marinas Section */}
      <Box className="for-marinas-section">
        <Container maxWidth="lg">
          <div className="for-marinas-content">
            <div className="for-marinas-left">
              <span className="for-marinas-label">FOR MARINAS</span>
              <h2 className="for-marinas-headline">
                Showcase your marina<br /> to a global audience.
              </h2>
            </div>
            <div className="for-marinas-separator"></div>
            <div className="for-marinas-middle">
              <p className="for-marinas-description">
                Mooringmate connects your marina with a global community of yacht owners and captains, making it easier to fill berths and welcome new guests.
              </p>
            </div>
            <div className="for-marinas-right">
              <Button
                onClick={() => navigate("/login")}
                className="btn-add-marina"
                endIcon={<ArrowForwardIcon />}
              >
                ADD YOUR MARINA
              </Button>
            </div>
          </div>
        </Container>
        <div className="for-marinas-image"></div>
      </Box>

      {/* Live Berths Map Section */}
      <Box id="available-berths" sx={{ py: 6, scrollMarginTop: "100px" }}>
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <h2 className="title">Available Berths Worldwide</h2>
            <p style={{ color: "#666", fontSize: "16px" }}>
              Explore available berths around the world. Search for locations and discover mooring opportunities.
            </p>
          </Box>
          <Box sx={{ maxWidth: "90%", margin: "0 auto" }}>
            <BerthMap />
          </Box>
        </Container>
      </Box>

      <Box>
        <Container maxWidth="lg">
          <Grid
            container
            spacing={3}
            sx={{
              alignItems: "center",
            }}
            style={{ paddingTop: "100px", paddingBottom: "40px" }}
          >
            <Grid item md={6}>
              <h6 className="sub-title">How does it work?</h6>
              <h2 className="title">
                Easily Rent or swap a Mooring for Your Boat
              </h2>
              <div className="section-content">
                <p style={{ marginBottom: '20px' }}>Looking for a mooring for your boat? Or do you have a mooring spot you'd like to rent out? Our platform makes the process simple, transparent, and efficient.</p>
                {/* <Link href="#contact">Get in touch</Link> */}
              </div>
            </Grid>
            <Grid item md={6}>
              <img className="heroImage" alt="" src={DockingmateAbout} loading="lazy" />
            </Grid>
          </Grid>
        </Container>
      </Box>
      
      <Box>
        <Container maxWidth="lg">
          <Grid
            id="services"
            className="empowering"
            container
            spacing={2}
            style={{ paddingTop: "40px", paddingBottom: "40px" }}
          >
            <Grid item md={12}>
              {/* <h6 className="sub-title">Fuel connections</h6> */}
              <h2 className="title">
                Mooringmate - Enabling sustainable mooring and mobility
              </h2>
            </Grid>
            <Grid item md={4} sm={6}>
              <Card className="blog-card" onClick={() => navigate("/login")} style={{ cursor: 'pointer' }}>
                <CardContent>
                  <div
                    className="blog-thumb"
                    style={{ backgroundImage: `url(${GreenmateAbout})` }}
                  ></div>
                  <h3>
                    Berth rentals <ChevronRightIcon />
                  </h3>
                  <p>Turn your mooring into income Have an available berth? List it in just a few steps, set your price, and start renting it out. Mooringmate helps you maximise the value of your mooring while contributing to a more sustainable yachting community.</p>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={4} sm={6}>
              <Card className="blog-card" onClick={() => navigate("/login")} style={{ cursor: 'pointer' }}>
                <CardContent>
                  <div
                    className="blog-thumb"
                    style={{ backgroundImage: `url(${SwappingYourBerth})` }}
                  ></div>
                  <h3>
                    Swapping your berth
                    <ChevronRightIcon />
                  </h3>
                  <p>Explore more, without extra mooring costs Easily swap your berth with other yacht owners through Mooringmate. Discover new destinations while keeping your costs low. Our secure and user-friendly platform gives you the flexibility to enjoy more time on the water.</p>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={4} sm={6}>
              <Card className="blog-card" onClick={() => navigate("/login")} style={{ cursor: 'pointer' }}>
                <CardContent>
                  <div
                    className="blog-thumb"
                    style={{ backgroundImage: `url(${HowitWorks})` }}
                  ></div>
                  <h3>
                    How it works <ChevronRightIcon />
                  </h3>
                  <p>List. Match. Sail.</p>
                  <p>Whether you're renting or swapping, Mooringmate makes the process simple. List your berth, find the perfect match, complete the payment, and we'll handle all the paperwork and administration.</p>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box className="service-fees-section">
        <Container maxWidth="lg">
          <Grid container spacing={4} style={{ paddingTop: "60px", paddingBottom: "60px" }}>
            <Grid item md={7} sm={12} xs={12}>
              <h6 className="sub-title">Transparent pricing</h6>
              <h2 className="title">Service Fees</h2>
              <p className="service-fees-body">At Mooringmate, we believe in clarity and fairness. We operate on a commission-based model.</p>
              <p className="service-fees-body">For every confirmed booking made through the platform, we charge a 10% service fee.</p>
              <ul className="service-fees-list">
                <li>No listing fees</li>
                <li>No subscription costs</li>
                <li>No hidden charges</li>
              </ul>
              <div className="service-fees-callout">
                <p>You only pay when your berth is successfully booked.</p>
                <p><strong>No cure, no pay.</strong></p>
              </div>
            </Grid>
            <Grid item md={5} sm={12} xs={12}>
              <div className="service-fees-partners-card">
                <h3 className="service-fees-subheading">Professional &amp; Portfolio Partners</h3>
                <p className="service-fees-body">For professional berth operators or partners managing multiple berths, tailored partnership agreements may apply.</p>
                <p className="service-fees-body">If you operate a larger portfolio and are interested in a strategic collaboration, we invite you to contact us directly to discuss a customised structure.</p>
                <hr className="service-fees-divider" />
                <p className="service-fees-goal">Our goal is simple: to create a transparent, efficient and professional marketplace that benefits both berth owners and yacht owners.</p>
              </div>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box id="faq" className="hideFaq">
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            style={{ paddingTop: "40px", paddingBottom: "80px" }}
            sx={{
              alignItems: "end",
            }}
          >
            <Grid item md={12} sm={12} xs={12}>
              <div className="title-section">
                <h2 className="title" style={{ marginBottom: "0px" }}>Frequently Asked Questions</h2>
                <LanguageDropdown
                  languages={languages}
                  defaultLang="en"
                  onLanguageChange={setSelectedLang}
                />
              </div>
              <MooringmateFAQ />
            </Grid>
          </Grid>
        </Container>
      </Box>
      
      {/* <Box>
        <Container maxWidth="lg">
          <Grid
            id="contact"
            container
            spacing={2}
            style={{ paddingTop: "40px", paddingBottom: "80px" }}
            sx={{
              alignItems: "end",
            }}
          >
            <Grid item md={6} sm={12} xs={12}>
              <Grid item md={12}>
                <h6 className="sub-title">Get in touch</h6>
                <h2 className="title">Connect with us for support</h2>
              </Grid>
              <ContactForm />
            </Grid>
            <Grid item md={6} sm={12} xs={12}></Grid>
          </Grid>
        </Container>
      </Box> */}
      <GeneralFooter />
    </Box>
  );
};
